import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';
import { SpielgeldRechner } from '../../../../components/SpielgeldRechner.jsx';

export function SpielgeldRechnerRender({ node, isLiveMode }) {
  const content = node.content || {};

  return (
    <div style={{ pointerEvents: !isLiveMode ? 'none' : 'auto', width: '100%', maxWidth: '800px', margin: '0 auto' }}>
      <SpielgeldRechner 
        isStandalone={false} 
        activeEvent={content.activeEvent || 'default'}
      />
    </div>
  );
}

registry.register('SpielgeldRechner', {
  label: 'Spielgeld Rechner',
  icon: '🧮', 
  category: 'tef',
  component: SpielgeldRechnerRender,
  
  defaultProps: {
    content: {
      activeEvent: 'default'
    },
    style: {
      desktop: {
        padding: '20px 0'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Einstellungen',
          fields: [
            { name: 'content.activeEvent', label: 'Promo/Event Vorauswahl', type: 'select', options: [
              { value: 'default', label: 'Standard (Kein Event)' },
              { value: 'blackfriday', label: 'Black Friday Deals' },
              { value: 'backtoschool', label: 'Back to School' }
            ]}
          ]
        }
      ]
    }
  ]
});
